import { makeStyles } from '@material-ui/core/styles';
import { grey, isDark } from 'global/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    marginBottom: theme.spacing(2),
  },
  filters: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    '@media print': {
      display: 'none',
    },
    '&> :first-child': {
      marginRight: theme.spacing(2),
    },
  },
  overline: {
    marginLeft: theme.spacing(1),
  },
  filterContainer: {
    boxShadow: '0px 0px 6px rgba(0,0,0,0.5)',
    borderRadius: 5,
    padding: theme.spacing(1),
    paddingTop: theme.spacing(0.5),
    marginTop: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
  },
  buttonGroup: {
    margin: theme.spacing(0.25),

    '& .MuiButton-contained.Mui-disabled': {
      backgroundColor: isDark(theme) ? grey(theme, 600) : grey(theme, 100),
      color: theme.palette.action.disabled,
    },

    '& .MuiButton-contained': {
      backgroundColor: isDark(theme) ? grey(theme, 700) : grey(theme, 300),
      color: theme.palette.getContrastText(isDark(theme) ? grey(theme, 700) : grey(theme, 300)),
      borderColor: isDark(theme) ? `${theme.palette.background.paper} !important` : undefined,

      '&:hover': {
        backgroundColor: theme.palette.action.hover,
      },
    },
  },
  buttonActive: {
    '&.MuiButton-contained': {
      backgroundColor: isDark(theme) ? grey(theme, 800) : grey(theme, 500),
    },
  },
  chipFilters: {
    paddingTop: theme.spacing(2),
    paddingBottom: 0,

    '& > .MuiChip-root': {
      marginRight: theme.spacing(1),
    },
  },
}));

export default useStyles;
